import React from 'react';

const Watermark = () => {
  return (
    <div className="fixed bottom-4 right-4 z-0 pointer-events-none">
      <div className="bg-gradient-to-br from-blue-500/10 to-teal-500/10 backdrop-blur-sm rounded-lg p-2 border border-white/20">
        <p className="text-xs font-light text-gray-500 rotate-[-5deg] tracking-wider">
          Del Mar a Tu Mesa © 2024
        </p>
      </div>
    </div>
  );
};

export default Watermark;